import {avatar, comp, Component, Config, createComponent, t} from "@intermesh/goui";
import {entities, img, principalDS} from "@intermesh/groupoffice-core";
import {Card} from "./Index.js";

export class CardComponent extends Component {
	private record: Card;

	constructor(record: Card) {
		super();
		this.record = record;

		this.cls = "bg-lowest kanban-card card";

		const linkConfig = entities.getLinkConfig(this.record.entity)!;

		this.items.add(
			comp({cls: "kanban-card-inner vbox"},
				comp({cls: "hbox"},
					comp({
						flex: 1,
						cls: "kanban-card-title",
						text: this.record.entityData.title ?? this.record.entityData.name
					}),
					comp({},
						comp({
							tagName: "i",
							title: t(this.record.entity),
							cls: "icon " + linkConfig.iconCls
						})
					),
				),
				comp({
					cls: "kanban-card-avatar-container",
					listeners: {
						render: async ({target}) => {
							if (!this.record.responsibleUserIds || this.record.responsibleUserIds.length === 0) {
								return
							}

							const users = await principalDS.get(this.record.responsibleUserIds);

							for (let i = 0; i < users.list.length; i++) {
								const user = users.list[i];
								const leftPosition = `${i * 2}rem`;

								const avatarComp = comp({
										title: user.name,
										cls: "meta kanban-card-avatar",
										style: {zIndex: `${100 - i}`, left: leftPosition},
										listeners: {
											render: (cmp) => {
												(cmp.target.el as HTMLElement).style.setProperty('--avatar-left', leftPosition);
											}
										}
									},
									user.avatarId ?
										img({
											cls: "kanban-card-avatar-img goui-avatar",
											blobId: user.avatarId,
											title: user.name
										}) :
										avatar({
											cls: "kanban-card-avatar-img goui-avatar",
											displayName: user.name
										})
								);

								target.items.add(avatarComp);
							}
						}
					}
				}),
			)
		)
	}
}

export const cardComp = (config: Config<CardComponent> & {
	record: Card
}) => createComponent(new CardComponent(config.record), config);